import { Button, Input } from '@artosera/ui';
import type { JSX } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';
import { authApi } from '../../api/auth.js';
import { estApiError, estErreurReseau } from '../../api/errors.js';
import { AuthCard } from '../AuthCard.js';
import { Field } from '../Field.js';
import styles from './ConnexionPage.module.css';

/** `/mot-de-passe/reinitialiser/:token`. */
export function MotDePasseReinitialiserPage(): JSX.Element {
  const { t } = useTranslation('regie');
  const params = useParams<{ token: string }>();
  const jeton = params.token ?? '';

  const [motDePasse, setMotDePasse] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [succes, setSucces] = useState(false);
  const [erreur, setErreur] = useState<string | null>(null);
  const [enCours, setEnCours] = useState(false);

  async function soumettre(): Promise<void> {
    setErreur(null);
    if (motDePasse !== confirmation) {
      setErreur(t('auth.reinitialiser.erreurConfirmation'));
      return;
    }
    setEnCours(true);
    try {
      await authApi.motDePasseReinitialiser(jeton, motDePasse);
      setSucces(true);
    } catch (error) {
      if (estApiError(error)) {
        setErreur(error.message);
      } else if (estErreurReseau(error)) {
        setErreur(t('auth.connexion.erreurReseau'));
      } else {
        setErreur(t('commun.erreurReseau'));
      }
    } finally {
      setEnCours(false);
    }
  }

  if (succes) {
    return (
      <AuthCard title={t('auth.reinitialiser.titre')}>
        <p className={styles.statut} role="status">
          {t('auth.reinitialiser.succes')}
        </p>
        <p className={styles.lienOubli}>
          <Link to="/connexion">{t('auth.reinitialiser.lienVersConnexion')}</Link>
        </p>
      </AuthCard>
    );
  }

  return (
    <AuthCard title={t('auth.reinitialiser.titre')}>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          void soumettre();
        }}
        noValidate
      >
        <Field label={t('auth.reinitialiser.champMotDePasse')} htmlFor="reinit-mot-de-passe">
          <Input
            id="reinit-mot-de-passe"
            type="password"
            autoComplete="new-password"
            required
            minLength={12}
            className={styles.pleineLargeur}
            value={motDePasse}
            onChange={(event) => setMotDePasse(event.target.value)}
          />
        </Field>
        <Field label={t('auth.reinitialiser.champConfirmation')} htmlFor="reinit-confirmation">
          <Input
            id="reinit-confirmation"
            type="password"
            autoComplete="new-password"
            required
            minLength={12}
            className={styles.pleineLargeur}
            value={confirmation}
            onChange={(event) => setConfirmation(event.target.value)}
          />
        </Field>

        {erreur ? (
          <p className={styles.erreur} role="alert">
            {erreur}
          </p>
        ) : null}

        <Button type="submit" className={styles.envoi} loading={enCours}>
          {t('auth.reinitialiser.bouton')}
        </Button>
      </form>
    </AuthCard>
  );
}
